export default __webpack_public_path__ + "static/icon-13-5-090117b127727995bacae407c85e3c79.png";